<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        > 
            <v-card
                class="pa-6" 
                width="500"
            >
                <v-row class="mt-3">
                    <p class="font-weight-light">
                        I agree to the following
                    </p>
                </v-row>
                <v-checkbox
                    label="School Rules"
                    v-model="studentRecord.school_rules"
                    @change="updateStore"
                    color="primary"                        
                ></v-checkbox>

                <v-checkbox
                    label="Laptop Policy"
                    v-model="studentRecord.laptop_policy"
                    @change="updateStore"
                    color="primary"                        
                ></v-checkbox>

                <v-checkbox
                    label="Cell Phone Policy"
                    v-model="studentRecord.cell_phone_policy"
                    @change="updateStore"
                    color="primary"                        
                ></v-checkbox>

                <v-row class="mt-3 ml-0">
                    <div class="d-flex align-content-start justify-start">

                        <v-checkbox
                            v-model="studentRecord.photo_video_policy"
                            @change="updateStore"
                            color="primary" 
                            class="mt-0"                       
                        ></v-checkbox>

                        <p class="font-weight-light">
                            To give permission for my child to be featured (pictures/videos) in the school's social media platforms and website.
                        </p>
                    </div>
                </v-row>
                
                

                <v-row 
                    align="center"
                    justify="center"
                    v-show="printButton" 
                    class="mt-4"                  
                >
                    <v-col
                        cols="12"
                        class="pl-0"                        
                    >
                        <!-- <v-btn
                            dark
                            color="primary"
                            @click="generatePDF"
                            block
                        >                            
                            <v-icon left>mdi-printer</v-icon>
                            Generate Registration Form
                        </v-btn>
                        <div 
                            class="mt-4 text-caption font-weight-light"                        
                        >8 1/2 x 14 (Legal) Sheet Required</div> -->
                    </v-col>
                </v-row>

                <v-card-actions>
                    <v-btn
                        depressed
                        color="primary"
                        block
                        @click="dialogSubmit = true"

                    >Submit Application</v-btn>
                </v-card-actions>
            </v-card>
        </v-row>
        
        <v-dialog
            v-model="registrationForm" 
            fullscreen
            transition="dialog-bottom-transition"
        >   
            <v-card
                height="100vh"
                v-if="registrationForm"
            >
                <v-toolbar
                    dark
                    color="primary"
                    height="30"
                >
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        small
                        dark
                        @click="closeRegistrationForm"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <iframe ref="pdf" style="width:100%; height:94%" frameBorder="0" :src="src"></iframe>                
            </v-card>
                            
        </v-dialog>

        <v-dialog
            v-model="dialogSubmit"
            width="400"
            persistent
        >
            <v-card>
                <v-card-title class="text-center">
                    <span class="mx-auto">Application Successfully Submitted</span>
                </v-card-title>
                <v-card-text>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
                    </svg>
                </v-card-text>

                <v-card-actions class="flex-column">
                        <v-btn
                            color="primary"
                            outlined
                            @click="generatePDF"
                            class="text-capitalize"
                            block
                        >
                            Click to Generate Application Form
                        </v-btn>
                         <div 
                            class="mt-0 text-caption font-weight-light"                        
                        >8 1/2 x 14 (Legal) Sheet Required</div>
                        <v-btn 
                            depressed 
                            block 
                            class="my-4" 
                            @click="dialogSubmit = false"
                        >
                            Close
                        </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>>
           
    </layout>
</template>

<script>
import Layout from './layouts/Registration';
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'Complete',
    components: {
        Layout,
    },

    data: () => ({
        printButton: true,        
        studentRecord: {},
        agree: false,
        registrationForm: false,
        iframe: null,        
        src: "",
        dialogSubmit: false,
    }),

    watch: {
        getStudentRecord : {
            handler () {
                this.initialize();
            },
        },

        
    },    
    computed: {
        ...mapGetters({
            getStudentRecord: 'auth/getStudentRecord',
            termsAndConditions: 'form/getTermsAndConditions',
            primaryColor: 'form/getPrimaryColor',
            colorDarken: 'form/getColorDarken',
            //registrationFormURI: 'auth/getRegistrationForm',
            student: 'auth/getUser',
            schoolName: 'form/getSchoolName',
        }),

        getAgree(){
            if(this.termsAndConditions == 1) return true;
            return false;
        },

        themeColor(){          
            return this.primaryColor + ' ' + this.colorDarken;
        }, 

    },
    methods: {
        initialize () {
            this.setStudentRecord();
            this.setAgree();
            this.setRegistrationForm();
        },

        ...mapMutations({
            updateStudentRecord: 'auth/setStudentRecord',
            setTermsAndCondtions: 'form/setTermsAndConditions',
        }),
        ...mapActions({
            saveRecord: 'auth/saveRecord',
            getRegistrationForm: 'auth/getRegistrationForm'
        }),
        updateStore(){
            if(this.agree){
                this.studentRecord.agree_terms_conditions = 1;
            }
            else{
                this.studentRecord.agree_terms_conditions = 0;
            }            
            this.updateStudentRecord(this.studentRecord);
            console.log(this.studentRecord);
            this.saveRecord()
                .then(response => {
                    console.log(response.status);
                })
                .catch(error =>{
                    console.log(error)
                    //this.saveError = true;
                });
        },
        setStudentRecord(){
            this.studentRecord = {...this.getStudentRecord}            
        },                
        setAgree(){
            //console.log(this.getAgree);
            if(this.getAgree == 1) this.agree = true;
            else this.agree = false;
        },
        generatePDF(){
           this.registrationForm = true;
           //console.log(this.registrationFormURI);
        },
        setRegistrationForm(){
            this.src = process.env.VUE_APP_API_URI + '/api/registration-form?student_id=' + this.student.student_id;
            //console.log(this.registrationFormURI)            
        },
        closeRegistrationForm(){            
            this.registrationForm = false
        },
    }
}
</script>

<style scoped>
svg {
        width: 100px;
        display: block;
        margin: 40px auto 0;
    }

    .path {
        stroke-dasharray: 1000;
        stroke-dashoffset: 0;
    }

    .path.circle {
        -webkit-animation: dash 0.9s ease-in-out;
        animation: dash 0.9s ease-in-out;
    }

    .path.line {
        stroke-dashoffset: 1000;
        -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
        animation: dash 0.9s 0.35s ease-in-out forwards;
    }

    .path.check {
        stroke-dashoffset: -100;
        -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
        animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }

    @-webkit-keyframes dash {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }

    @keyframes dash {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }

    @-webkit-keyframes dash-check {
        0% {
            stroke-dashoffset: -100;
        }
        100% {
            stroke-dashoffset: 900;
        }
    }

    @keyframes dash-check {
        0% {
            stroke-dashoffset: -100;
        }
        100% {
            stroke-dashoffset: 900;
        }
    }
    </style>